export default {
	path: '/',
	icon: '',
	meta: {
		title: '申论批改'
	},
	children: [
		{
			path: '/essay/examination/paper',
			icon: '',
			name: 'examinationPaperIndex',
			meta: {
				title: '试卷管理'
			},
			component: () => import('@/views/essay/examination/paper')
		},
		{
			path: '/essay/examination/correction',
			icon: '',
			name: 'examinationCorrectionIndex',
			meta: {
				title: '试卷批改'
			},
			component: () => import('@/views/essay/examination/correction')
		}
	]
}
